import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#050505] py-8 px-4 border-t border-white/5 mt-12" data-id="element-149">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-150">
        <p className="font-playfair text-xl text-white mb-4 tracking-widest uppercase" data-id="element-151">
          Ludmila Reyes
        </p>
        <p className="font-inter text-xs text-gray-500 mb-2" data-id="element-152">
          © {new Date().getFullYear()} Ludmila Reyes. Todos los derechos
          reservados.
        </p>
        <div className="flex gap-4 text-xs text-gray-500 font-inter" data-id="element-153">
          <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-154">
            Términos de Servicio
          </a>
          <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-155">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}